import {Button, Card, Descriptions, Empty, Form, Select, Spin, Tag} from 'antd';
import React from "react";
import DocumentList from "../../components/DocumentList";

class UploadDocument extends React.Component {

  state = {
    showReadings: false,
    documentData: [],
    id: '',
  };

  componentDidMount() {
    this.props.clearData();
    const {fetch, match} = this.props;
    if(match.params && match.params.asset) {
      fetch(match.params.asset);
      this.setState({
        id: match.params.asset,
        documentData: [],
      });
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
  }

  getDocumentData = (data) => {
    this.setState({documentData: data});
  };

  onSelectAsset = (e) => {
    const {fetch} = this.props;
    fetch(e);
    this.setState({
      id: e,
      documentData: [],
    });
  };

  handleSearch = value => {
    this.setState({value});
    this.props.fetchRelationshipSearchData(value, 'Asset', 'assetCode');
  };


  handleSubmit = (e) => {
    const {match, item, loading, resource} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      const {documentData} = this.state;
      const data = {};
      if(documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }
      if(this.state.id) {
        this.props.onSubmit(data, this.state.id);
        this.setState({
          documentData: [],
        });
        this.props.form.resetFields();
      }
    });
  };

  componentWillUnmount() {
    this.props.clearData();
  }

  documentEditHandler = (recordData, asset) => {
    this.props.history.push(`/document/editAsset/${recordData._id}/${asset}`);
    // console.log('recordData', recordData, asset);
  }


  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {data, loading, filters, subDocumentFilters, title, resource, form, item, isDisabled, history, match, authUser, searchData} = this.props;
    const {documentData} = this.state;

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '10px',
      borderRadius: '9px',
      display: 'flex',
      width: 'calc(50% - 5px)',
      justifyContent: 'space-between'
    };

    const formItems = (data && data.documents || []).map((item, index) => {
      return <div key={index} style={style}>
        <div style={{width: '100%'}}>
          {/*{item.name} - <span>{item && item.file && item.file.path ? <a href={item && item.file && item.file.path} target="_blank">{item && item.file && item.file.name}</a> : <span>{item && item.file && item.file.name}</span>}</span>*/}
          {(item.type && item.type.name) ?
            <Tag color={'blue'}>{item.type.name} </Tag> : ''}{item.name} - <span>{item && item.file && item.file.path ? <>
          <a href={item && item.file && item.file.path} target="_blank">{item && item.file && item.file.name}</a>
          <Button
            type={"primary"}
            style={{float: "right"}}
            onClick={this.documentEditHandler.bind(this, item, data._id)}>Edit</Button>
        </> : <span>{item && item.file && item.file.name}</span>}</span>
        </div>
      </div>
    });

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}
              title={`Upload Documents ${data && data.assetCode ? `- ${data.assetCode}` : ''}`}>
          <label style={{display: 'block', marginBottom: '5px'}}>Search Asset To Upload Document</label>
          <Select
            filterOption={(input, option) =>
              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            }
            onSearch={this.handleSearch}
            style={{width: '50%', marginBottom: '10px'}}
            onSelect={this.onSelectAsset.bind(this)}
            showSearch
            allowClear
            placeholder={'Search Asset'}>
            {
              searchData && searchData.map((item) => {
                return <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>
              })
            }
          </Select>

          {
            Object.keys(data).length ? <div style={{marginTop: '10px'}}>
              <Descriptions
                layout='vertical'
                bordered
                style={{marginBottom: '20px'}}
                size={"middle"}
              >
                <Descriptions.Item
                  label="Asset Sub Type">{data && data.equipmentSubType && data.equipmentSubType.name}</Descriptions.Item>
                <Descriptions.Item
                  label="Location">{(data && data.location && data.location.name) || data && data.status}</Descriptions.Item>
                <Descriptions.Item label="Sub Location">{data && data.client && data.client.name}</Descriptions.Item>
              </Descriptions>

              <div>Documents</div>
              <div style={{display: 'flex', width: '100', flexWrap: 'wrap', justifyContent: 'space-between'}}>
                {formItems}
              </div>
              {
                filters['documents'] && filters['documents'].type === 'Array' && filters['documents'].options.ref === 'Document' &&
                <DocumentList clearData={true} match={this.props.match} hideRemove={true} history={this.props.history}
                              key={'documents'} item={filters['documents']} form={form} data={data.documents || []}
                              subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
              }

              {/*<Button type="primary" disabled={documentData && !documentData.length} className="gx-mb-0" htmlType="button" onClick={this.handleSubmit} loading={loading}>*/}
              {/*  UPDATE*/}
              {/*</Button>*/}
              <Button type="primary" className="gx-mb-0" htmlType="button" onClick={this.handleSubmit}
                      loading={loading}>
                UPDATE
              </Button>
            </div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}>Search Asset To Upload Document</Empty>
          }
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(UploadDocument);


export default CreateForm;

